import React from 'react';
import { EditorWizardContext } from '../../../hoc/EditorWizard';
import { LocalizationContext } from '../../../hoc/Localization';
import StepContainer from '../StepContainer';
import Contacts from './Contacts';

const UserContacts = () => {
  const { t } = React.useContext(LocalizationContext);
  const { updateContent, step, edited } = React.useContext(EditorWizardContext);
  const [passedEmail, setPassedEmail] = React.useState(false);
  const [passedPhone, setPassedPhone] = React.useState(false);
  const { email, schoolTitle, phone } = edited;

  const setValue = (data, key) => {
    updateContent(key, data);
  };

  React.useEffect(() => {
    function validateEmail(e) {
      const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(e).toLowerCase());
    }
    if (email) {
      const valid = validateEmail(email);
      if (valid) {
        setPassedEmail(true);
      } else {
        setPassedEmail(false);
      }
    }
  }, [email]);

  React.useEffect(() => {
    function validatePhoneNumber(e) {
      const pattern = /^((\+?[1-9][0-9]{1,2})|0)([0-9]{8,10})$/;
      return pattern.test(e.toString());
    }
    if (phone) {
      const valid = validatePhoneNumber(phone);
      if (valid) {
        setPassedPhone(true);
      } else {
        setPassedPhone(false);
      }
    }
  }, [phone]);

  React.useEffect(() => {
    if (phone && phone.indexOf(' ') >= 0) {
      const readyPhone = phone.replace(/ /g, '');
      updateContent('phone', readyPhone);
    }
  }, []);
  return (
    <StepContainer
      nextButtonDisabled={!passedEmail || !schoolTitle || !passedPhone || !phone}
      nextButtonNotPassed={!passedEmail && !passedPhone}
      step={step}
    >
      <Contacts t={t} phone={phone} schoolTitle={schoolTitle} email={email} setValue={setValue} />
    </StepContainer>
  );
};

export default UserContacts;
